import React, { useReducer, useEffect } from 'react';
import loadingIconSrc from '../../../styles/assets/images/laoding-clock-white.gif';
import siteReducer from '../../../reducers/siteDetails';
import * as actions from '../../../actions/siteDetails';

const initialState = { base64Image: null };
const ManageImage = ({ data }) => {
    const [state, dispatch] = useReducer(siteReducer, initialState);
    const { base64Image } = state;

    useEffect(() => {
        let imageData = {
            'fileName': data,
            'folderName': 'SiteImage'
        }
        actions.fetchImage(dispatch, imageData);
    }, [data])
    return (
        <>
            {base64Image === null
                ?
                <p><img src={loadingIconSrc} width="120" height="120" /></p>
                :
                <img src={base64Image} style={{ height: '500px', width: 'auto' }} />
            }
        </>
    );
};

export default ManageImage;